import React from 'react';
import useInView from 'react-cool-inview';
import { Venues } from '@weddingspot/ws-api-client';
import { FeatureFlagContext, FLAG_VENUE_PROFILE_PAGE_REVIEW } from '@weddingspot/ws-core-components';

import Spaces from '../sections/spaces';
import UpcomingEvents from '../sections/UpcomingEvents/UpcomingEvents';
import styles from '../styles.module.scss';
import { Reviews } from '../sections/Reviews';
import AvailabilityCalendar from '../sections/AvailabilityCalendar/AvailabilityCalendar';
import GuestRoomsSection from '../sections/GuestRooms';
import Packages from '../sections/Packages';
import { VenueProfileContext } from '../context';
import VenueLocation from '../sections/VenueLocation/VenueLocation';
import Pinterest from '../sections/Pinterest/Pinterest';
import Links from '../sections/Links/Links';
import { Icons } from 'components/ui';

const LazyBody = () => {
    const context = React.useContext(VenueProfileContext);
    const { flagEnabled } = React.useContext(FeatureFlagContext);

    const { observe: locationsObserve, inView: locationsInView } = useInView({
        onEnter: ({ unobserve }) => unobserve(),
    });

    const wsVenueProfile = React.useMemo(() => context.wsVenueProfile, [context.wsVenueProfile]) as Venues.VenueDetails;

    let tokens = [];
    let addressLine = '';

    if (!!wsVenueProfile.address_1){
        tokens.push(wsVenueProfile.address_1);
    }
    if (!!wsVenueProfile.address_2) {
        tokens.push(wsVenueProfile.address_2);
    }
    if (!!wsVenueProfile.city) {
        tokens.push(wsVenueProfile.city);
    }
    if (!!wsVenueProfile.state) {
        tokens.push(wsVenueProfile.state.replace('C-', ''));
    } else if (!!wsVenueProfile.province) {
        tokens.push(wsVenueProfile.province);
    }

    addressLine += tokens.join(', ');
    if (!!wsVenueProfile.zip_code) {
        addressLine += ` ${wsVenueProfile.zip_code}`;
    }
    if(!wsVenueProfile.state && !!wsVenueProfile.country){
        addressLine += `, ${wsVenueProfile.country}`;
    }

    return (
        <>
            {!context.csnVenueProfileLoading && !!context.csnVenueProfile && (
                <div id='spaces'>
                    <Spaces />
                </div>
            )}

            <UpcomingEvents />
            <Pinterest />

            <h2 className={styles.title}>Venue Location</h2>
            {!!addressLine && (
                <div className={styles.addressLine}>
                    <Icons.Location /> 
                    {addressLine}
                </div>
            )}
            <div className={styles.sectionMap} id='map' ref={locationsObserve}>
                {locationsInView && <VenueLocation />}
            </div>

            {flagEnabled(FLAG_VENUE_PROFILE_PAGE_REVIEW) && (
                <div id='reviews'>
                    <Reviews />
                </div>
            )}

            {wsVenueProfile.availability !== null && (
                <div>
                    <AvailabilityCalendar />
                </div>
            )}

            <div id='rooms'>
                <GuestRoomsSection
                    wsVenueAddress={wsVenueProfile.address_1}
                    city={wsVenueProfile.city}
                    state={wsVenueProfile.state}
                    zipCode={wsVenueProfile.zip_code}
                />
            </div>

            <Packages />
            <Links
                website={wsVenueProfile.website}
                facebook_link={wsVenueProfile.facebook_link}
                instagram_link={wsVenueProfile.instagram_link}
                pinterest_link={wsVenueProfile.pinterest_link}
            />
        </>
    );
};

export default LazyBody;
